import { type TFunction } from 'react-i18next';
import DraggableStepCard, { DraggableStepCardProps } from '../../DraggableStepCard';
import { getValueOrDeleted } from './action-helpers';
import { type ModifyAutomationStep } from 'pages/AutomationEngine/dialogs/ActionWizard/subsections/actionSectionTypes';

export const content = ({ step }: { step: ModifyAutomationStep }) =>
  step.description;

export const getDescription = ({
  step: { details },
  t,
}: {
  step: ModifyAutomationStep;
  t: TFunction;
}) => {
  const { recordSource, relationshipFields, automationVariable, automations } =
    details;

  const actionType = details.actionType === 'pause' ? t('Pause') : t('Cancel');

  const automationsToStart = automations
    .map(
      ({ label, deleted }) => `${label}${deleted ? ` [${t('Deleted')}]` : ''}`
    )
    .sort((a, b) => {
      return a.localeCompare(b, 'en', { sensitivity: 'base' });
    })
    .join(', ');

  if (recordSource === 'automation_variable' && automationVariable) {
    const variableName = `${automationVariable.label}${automationVariable.deleted ? ` [${t('Deleted')}]` : ''}`;
    return t(
      `{{actionType}} '{{automationsToStart}}' on Variable '{{variableName}}'`,
      { automationsToStart, variableName, actionType }
    );
  }

  if (recordSource === 'related_object_field') {
    const relationshipFieldNames = getValueOrDeleted(
      relationshipFields
        .map(
          ({ label, deleted }) =>
            `${label}${deleted ? ` [${t('Deleted')}]` : ''}`
        )
        .sort((a, b) => {
          return a.localeCompare(b, 'en', { sensitivity: 'base' });
        })
        .join(', '),
      t
    );

    return t(
      `{{actionType}} '{{automationsToStart}}' on '{{relationshipFieldNames}}'`,
      {
        automationsToStart,
        relationshipFieldNames,
        actionType,
      }
    );
  }

  return t(`{{actionType}} '{{automationsToStart}}'`, {
    automationsToStart,
    actionType,
  });
};

export default function ModifyAutomationsCard({
  step,
  ...others
}: {
  step: ModifyAutomationStep;
} & DraggableStepCardProps) {
  return <DraggableStepCard {...others}>{content({ step })}</DraggableStepCard>;
}
